<template>
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Type
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item prop="dataType" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change'
                  }">
                    <el-select clearable v-model="detailInfo.dataType" name="status">
                      <el-option v-for="item in typeObj" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Start time<span style="color:red">*</span></label>
                <div class="col-sm-5">
                  <el-form-item prop="begDate" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change'
                  }">
                    <el-date-picker v-model="detailInfo.begDate" type="date" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> End time <span style="color:red">*</span></label>
                <div class="col-sm-5">
                  <el-form-item prop="endDate" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change'
                  }">
                    <el-date-picker v-model="detailInfo.endDate" type="date" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="checkEvent()">
                      Export
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        dataType: "",
        begDate: "",
        endDate: "",
      },
      typeObj: [],

    };
  },
  created() {

    this.typeObj = [
      {
        value: 1,
        label: "Login/Logout"
      },
      {
        value: 2,
        label: "Item Record"
      },
      {
        value: 3,
        label: "Staff Record"
      },
      {
        value: 4,
        label: "App Record"
      },
      {
        value: 5,
        label: "School Portal"
      }
    ];
  },
  methods: {
    checkEvent() {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {

      var start = new Date(this.detailInfo.begDate).getTime();
      var end = new Date(this.detailInfo.endDate).getTime()
      if (!(this.$dayjs(end).diff(this.$dayjs(start), 'day') < 183 && this.$dayjs(end).diff(this.$dayjs(start), 'day')>=0)) {
        this.$message({
          message: 'The maximum period for audit report generation is half year.', 
          type: 'warning'
        });
        return;
      }
      let obj = this.getAuthObj();
      obj.dataType = this.detailInfo.dataType;
      obj.begDate = this.detailInfo.begDate;
      obj.endDate = this.detailInfo.endDate;
      obj.apiUrl = this.apiConfig.download;
      let data = await this.$store.dispatch("apiEventFromDataDownload", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement('a');
      link.href = url;
      if (this.detailInfo.dataType == 1) {
        link.setAttribute('download', 'LoginLogoutRecord.xls');
      } else {
        link.setAttribute('download', 'ItemChangeRecord.xls');
      }

      document.body.appendChild(link);
      link.click();
    },
  },
  mounted() {
  }
};
</script>
